/**
 * ACCourseNotificationChannelService
 * Service for managing per-NotificationType channel toggles
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for notification channel setting operations (getAll + update)
 */
export class ACCourseNotificationChannelService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ACCourseNotificationChannelService.DEFAULT_SERVICE_PATH,
            basePath: ACCourseNotificationChannelService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
ACCourseNotificationChannelService.DEFAULT_SERVICE_PATH = 'ac-courses';
ACCourseNotificationChannelService.BASE_PATH = 'api/course-notification-channels';
//# sourceMappingURL=ACCourseNotificationChannelService.js.map